<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-title w-100 p-2 mb-0">
          <div class="row align-items-center">
            <div class="col-xl-3 col-12 mb-md-1" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>
            <div class="col-xl-3 col-12 mb-md-1" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <div class="d-flex">
                <label for="monthYear" class="mb-0" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
                  <select [(ngModel)]="selectedMonth" (ngModelChange)="loadData()" id="monthYear" class="form-control pr-3 text-capitalize">
                    <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                    <option *ngFor="let month of availableMonths" [value]="month" [label]="formatLabel(month)">{{ month }}</option>
                  </select>
                </label>
                <label for="years" class="mb-0 ml-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
                  <select id="years" [(ngModel)]="selectedYear" (change)="loadData()" class="form-control pr-3">
                    <option selected disabled value="all">{{ "YEAR" | translate }}</option>
                    <option *ngFor="let year of availableYears">{{ year }}</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-xl-6 text-right col-12 mb-md-1" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
                <label for="page_quantity" class="d-flex align-items-center"
                >{{ "SHOW" | translate }}
                  <select id="page_quantity" class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <button class="btn btn-outline-primary" *ngIf="_authenticationService.hasCapability('create_provider_cost')" (click)="openModal(costModal, null, null)">{{ "ADD" | translate }}</button>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <ngx-datatable
            #table
            class="bootstrap core-bootstrap material expandable"
            columnMode="force"
            [headerHeight]="30"
            [footerHeight]="50"
            [rowHeight]="_utilService.isDesktop ? 70 : 350"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [scrollbarH]="true"
            [limit]="tableLimit"
            [rows]="filterProvidersCostList"
          >
            <!-- Row Detail Template -->
            <ngx-datatable-row-detail [rowHeight]="calculateChildrenRowHeight()" #myDetailRow>
              <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                <div class="child-datatable">
                  <div class="row mb-1" *ngFor="let child of row.children">
                    <div class="col-lg-3">
                      <span class="mr-1 text-break-line-1" container="body" [ngbTooltip]="child.amount_description" placement="bottom">{{ child.amount_description }}</span>
                    </div>
                    <div class="col-lg-2">
                      <a class="ml-lg-5" *ngIf="child.collaborator" target="_blank" routerLink="/dashboard/collaborators/edit/{{child.collaborator.hash}}">{{ child.collaborator.name }}</a>
                    </div>
                    <div class="col-lg-2 ml-lg-2">
                      <span class="ml-lg-5">{{ child.amount | currency: 'EUR' }}</span>
                    </div>
                    <div class="col-lg-3 text-right">
                      <button class="bg-transparent border-0 text-secondary" (click)="openModal(costModal, child, row)" container="body" [ngbTooltip]="'EDIT' | translate" has_capability="edit_provider_cost">
                        <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                      </button>
                      <button class="bg-transparent border-0 text-danger" (click)="delete(child)" container="body" [ngbTooltip]="'DELETE' | translate" has_capability="delete_provider_cost">
                        <span [data-feather]="'trash-2'" size="16"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-row-detail>

            <!-- Column Templates -->
            <ngx-datatable-column [width]="50" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
              <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
                <a *ngIf="row.children && row.children.length > 0" href="javascript:void(0)" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row, expanded)">
                </a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TITLES.USERS_TYPES_SINGULAR.external' | translate" prop="provider.name" *ngIf="_utilService.isDesktop" [width]="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img #image (error)="image.hidden = true" (load)="image.hidden = false" src="{{ row?.provider.logo }}" class="mr-1" [alt]="row.name" width="32" height="32" />
                  <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                    <div class="avatar-content text-uppercase">{{ row.provider.name[0] }}</div>
                  </div>
                  <a routerLink="/dashboard/provider/{{ row.provider.id }}">{{ row.provider.name }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'DESCRIPTION' | translate" prop="amount_description" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="text-break-line-2" [ngbTooltip]="row.amount_description">{{ row.amount_description }}</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'COLLABORATOR' | translate" prop="collaborator.name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a *ngIf="row.collaborator" target="_blank" routerLink="/dashboard/collaborators/edit/{{row.collaborator.hash}}">{{ row.collaborator.name }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'AMOUNT' | translate" prop="amount" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div>{{ _utilService.addDotsToNumber(row.amount) }} €</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'COMMISSION' | translate" prop="commission.complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a *ngIf="row.commission.complete_name" class="text-break-line-2" [ngbTooltip]="row.commission.complete_name" [routerLink]="'/dashboard/commission/edit/' + row.commission.id">{{
                    row.commission.complete_name
                  }}</a>
                <div *ngIf="!row.commission.complete_name">-</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button
                    class="bg-transparent border-0 text-success"
                    (click)="_utilService.getFile(row.attachments[0].url)"
                    [ngbTooltip]="'VIEW_FILE_DOCUMENT' | translate"
                    *ngIf="row.attachments && row.attachments[0] && row.attachments[0].url"
                  >
                    <span [data-feather]="'file-text'" size="19"></span>
                  </button>
                  <button class="bg-transparent border-0 text-success" (click)="openModal(costModal, null, row)" [ngbTooltip]="'ADD' | translate" *ngIf="_authenticationService.hasCapability('create_provider_cost')">
                    <span [data-feather]="'plus'" size="16" class="mr-50"></span>
                  </button>
                  <button class="bg-transparent border-0 text-secondary" (click)="openModal(costModal, row, null)" [ngbTooltip]="'EDIT' | translate" *ngIf="_authenticationService.hasCapability('edit_provider_cost')">
                    <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                  </button>
                  <button class="bg-transparent border-0 text-danger" (click)="delete(row)" [ngbTooltip]="'DELETE' | translate" *ngIf="_authenticationService.hasCapability('delete_provider_cost')">
                    <span [data-feather]="'trash-2'" size="16"></span>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!-- mobile - tablet -->
            <ngx-datatable-column [name]="'TITLES.USERS_TYPES_SINGULAR.external' | translate" prop="provider.name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <div class="d-flex align-items-center">
                      <img #image (error)="image.hidden = true" (load)="image.hidden = false" src="{{ row?.provider.logo }}" class="mr-1" [alt]="row.name" width="32" height="32" />
                      <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                        <div class="avatar-content text-uppercase">{{ row.provider.name[0] }}</div>
                      </div>
                      <a routerLink="/dashboard/provider/{{ row.provider.id }}">{{ row.provider.name }}</a>
                    </div>
                    <div class="mt-1">
                      <p class="mb-0">{{ row.business_name }}</p>
                    </div>
                    <div>
                      <span>{{ "DESCRIPTION" | translate }}: </span>
                      <div>{{ row.amount_description }}</div>
                    </div>
                    <div>
                      <span>{{ "AMOUNT" | translate }}: </span>
                      <div>{{ _utilService.addDotsToNumber(row.amount) }} €</div>
                    </div>
                    <div>
                      <span>{{ "COMMISSION" | translate }}: </span>
                      <a *ngIf="row.commission.complete_name" class="text-break-line-2" [ngbTooltip]="row.commission.complete_name" [routerLink]="'/dashboard/commission/edit/' + row.commission.id">{{
                          row.commission.complete_name
                        }}</a>
                      <div *ngIf="!row.commission.complete_name">-</div>
                    </div>
                  </div>
                  <div class="col-10 mt-075 text-right">
                    <button
                      class="bg-transparent border-0 text-success"
                      (click)="_utilService.getFile(row.attachments[0].url)"
                      [ngbTooltip]="'VIEW_FILE_DOCUMENT' | translate"
                      *ngIf="row.attachments && row.attachments[0] && row.attachments[0].url"
                    >
                      <span [data-feather]="'file-text'" size="19"></span>
                    </button>
                    <button class="bg-transparent border-0 text-success" (click)="openModal(costModal, null, row)" [ngbTooltip]="'ADD' | translate" *ngIf="_authenticationService.hasCapability('create_provider_cost')">
                      <span [data-feather]="'plus'" size="16" class="mr-50"></span>
                    </button>
                    <button class="bg-transparent border-0 text-secondary" (click)="openModal(costModal, row, null)" [ngbTooltip]="'EDIT' | translate" *ngIf="_authenticationService.hasCapability('edit_provider_cost')">
                      <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                    </button>
                    <button class="bg-transparent border-0 text-danger" (click)="delete(row)" [ngbTooltip]="'DELETE' | translate" *ngIf="_authenticationService.hasCapability('delete_provider_cost')">
                      <span [data-feather]="'trash-2'" size="16"></span>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h4>{{ "TOTAL_AMOUNT" | translate }}: {{ _utilService.addDotsToNumber(totalAmount) }}€</h4>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Modal Cost -->
<ng-template #costModal let-modal>
  <form [formGroup]="formGroup">
    <div class="modal-header">
      <button type="button" class="close" (click)="modalClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>
        {{
          !editMode && !isSelectedAChild
            ? ("ADD_NEW_COST" | translate)
            : !editMode && isSelectedAChild
              ? ("ADD_NEW_BELOW_COST" | translate)
              : editMode && !isSelectedAChild
                ? ("EDIT_COST" | translate)
                : ("EDIT_BELOW_COST" | translate)
        }}
      </h3>
      <div class="row">
        <div class="form-group col-12">
          <label for="provider_id">{{ "TITLES.USERS_TYPES_SINGULAR.external" | translate }}:<sup class="text-danger">*</sup></label>
          <div
            class="cursor-pointer"
            *ngIf="isSelectedAChild || (selectedProviderCost && selectedProviderCost.provider && selectedProviderCost.provider.name && !showEditField.provider_id)"
            (click)="toggleField('provider_id')"
          >
            {{ selectedProviderCost && selectedProviderCost.provider && selectedProviderCost.provider.name ? selectedProviderCost.provider.name : parentProviderName }}
          </div>
          <ng-select *ngIf="showEditField.provider_id && !isSelectedAChild"
                     id="provider_id"
                     bindLabel="name"
                     bindValue="id"
                     formControlName="provider_id"
                     [multiple]="false"
                     [searchable]="true"
                     [closeOnSelect]="true"
                     class="{{ formHasError('provider_id') ? 'is-invalid' : '' }}"
                     (change)="handlerChaneProvider()"
                     [clearable]="false"
                     [openOnEnter]="false"
                     [virtualScroll]="true"
                     [items]="providers"
                     [readonly]="isSelectedAChild"
          ></ng-select>
          <div class="invalid-feedback" *ngIf="formGroup.controls.provider_id.errors?.required">{{ "ERRORS.SELECT_PROVIDER" | translate }}</div>
        </div>

        <div class="form-group col-12">
          <label for="collaborator_id">{{ "TITLES.USERS_TYPES_SINGULAR.collaborator" | translate }}:<sup class="text-danger">*</sup></label>
          <ng-template #selectedCollaborator>
            <div class="cursor-pointer" (click)="toggleField('collaborator_id')" *ngIf="isSelectedAChild || (selectedProviderCost && selectedProviderCost.collaborator && selectedProviderCost.collaborator.name)">
              {{ selectedProviderCost?.collaborator?.name }}
            </div>
            <div *ngIf="filteredCollaborators.length < 1" class="font-italic font-small-3">{{'NO_COLLABORATORS_FOUND_FOR_THIS_PROVIDER' | translate}}</div>
          </ng-template>
          <ng-select *ngIf="showEditField.collaborator_id; else selectedCollaborator"
                     id="collaborator_id"
                     bindLabel="complete_name"
                     bindValue="collaborator_id"
                     formControlName="collaborator_id"
                     [multiple]="false"
                     [searchable]="true"
                     [closeOnSelect]="true"
                     class="{{ formHasError('provider_id') ? 'is-invalid' : '' }}"
                     [clearable]="false"
                     [openOnEnter]="false"
                     [virtualScroll]="true"
                     [items]="filteredCollaborators"
                     [readonly]="filteredCollaborators.length < 1"
          ></ng-select>
          <div class="invalid-feedback" *ngIf="formGroup.controls.provider_id.errors?.required">{{ "ERRORS.SELECT_COLLABORATOR" | translate }}</div>
        </div>

        <div class="form-group col-12">
          <label for="amount">{{ "AMOUNT" | translate }}:<sup class="text-danger">*</sup></label>
          <div class="cursor-pointer" *ngIf="selectedProviderCost && selectedProviderCost.amount && !showEditField.amount" (click)="toggleField('amount')">
            {{ _utilService.addDotsToNumber(selectedProviderCost.amount) }}
          </div>
          <input *ngIf="showEditField.amount" id="amount" placeholder="3.000,00" type="text" class="form-control {{ formHasError('amount') ? 'is-invalid' : null }}" formControlName="amount" (change)="formatMoneyValue()" />
          <div class="invalid-feedback" *ngIf="formGroup.controls.amount.errors?.required">{{ "ERRORS.INSERT_INVOICE_AMOUNT" | translate }}</div>
        </div>
        <div class="form-group col-12">
          <label for="amount_description">{{ "DESCRIPTION" | translate }}<sup class="text-danger">*</sup></label>
          <div class="cursor-pointer" *ngIf="selectedProviderCost && selectedProviderCost.amount_description && !showEditField.amount_description" (click)="toggleField('amount_description')">
            {{ selectedProviderCost.amount_description }}
          </div>
          <textarea formControlName="amount_description" *ngIf="showEditField.amount_description" id="amount_description" [placeholder]="'DESCRIPTION' | translate" type="text"
                    class="form-control {{ formHasError('amount_description') ? 'is-invalid' : null }}"></textarea>
          <div class="invalid-feedback" *ngIf="formGroup.controls.amount_description.errors?.required">{{ "ERRORS.FIELD_DESCRIPTION" | translate }}</div>
        </div>
        <div class="form-group col-12" *ngIf="!isSelectedAChild">
          <label for="commission_id">{{ "DEAL_ORDER" | translate }}:</label>
          <div class="cursor-pointer" (click)="toggleField('commission_id')" *ngIf="selectedProviderCost && selectedProviderCost.commission && selectedProviderCost.commission.complete_name && !showEditField.commission_id">
            {{ selectedProviderCost.commission.complete_name }}
          </div>
          <div class="cursor-pointer" (click)="toggleField('commission_id')" *ngIf="selectedProviderCost && selectedProviderCost.commission && !selectedProviderCost.commission.complete_name && !showEditField.commission_id">
            -
          </div>
          <ng-select *ngIf="showEditField.commission_id" id="commission_id" bindLabel="complete_name" bindValue="id" formControlName="commission_id" [multiple]="false" [searchable]="true" [closeOnSelect]="true"
                     [clearable]="true" [openOnEnter]="false" [virtualScroll]="true" [items]="commissions"></ng-select>
        </div>
        <div class="col-12 form-group">
          <div class="row">
            <div class="col-12">
              <label for="attachment" (click)="toggleField('attachments')" class="cursor-pointer">{{ "FILE" | translate }}:</label>
              <div id="attachment-uploader" class="custom-file" *ngIf="showEditField.attachments">
                <input class="custom-file-input" type="file" lang="it" id="attachment" [multiple]="true" (change)="addAttachmentToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="editMode && (!selectedProviderCost || !selectedProviderCost.attachments || (selectedProviderCost && selectedProviderCost.attachments && selectedProviderCost.attachments.length < 1))">
            <div class="col-10 d-flex justify-content-between align-items-center mb-05 cursor-pointer" (click)="toggleField('attachments')"
                 *ngIf="selectedProviderCost && selectedProviderCost.attachments && selectedProviderCost.attachments.length < 1 && !showEditField.attachments">
              <div>{{ "NO_ONE_DOCUMENT_UPLOADED" | translate }}</div>
            </div>
          </div>
          <div class="row" *ngIf="selectedProviderCost && selectedProviderCost.attachments && selectedProviderCost.attachments.length > 0">
            <div class="col-12 d-flex align-items-center" *ngFor="let file of selectedProviderCost.attachments">
              <span class="badge badge-warning cursor-pointer mr-025" [ngbTooltip]="'VIEW' | translate" (click)="_utilService.getFile(file.url)"
              ><span class="mr-025" [data-feather]="'file-text'" size="16"></span>{{ file?.filename }}</span
              >
              <button type="button" class="btn border-0 px-0 text-danger" [ngbTooltip]="'DELETE' | translate" (click)="deleteAttachment(file.id)">
                <span [data-feather]="'trash-2'" size="16"></span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="attachments_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetAttachmentsList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 border-top pt-1" *ngIf="attachments_list_obj.length > 0">
              <div *ngFor="let file of attachments_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ attachments_list_obj.length }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()">
        {{ "BACK" | translate }}
      </button>
      <button type="button" class="btn btn-primary w-150" (click)="!editMode ? addNewCost() : editCost()" *ngIf="showEditField.provider_id || showEditField.amount || showEditField.amount_description || showEditField.commission_id || showEditField.attachments || showEditField.collaborator_id">
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Cost -->
